<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-subject-type" class="control-label">{{ inputLabel }}</label>
    <select
      id="form-subject-type"
      class="show-tick form-control"
      v-model="inputValue"
      @change="emit($event)"
      @input="emit($event)"
      :disabled="disabled"
    >
      <option
        v-for="subject in items"
        v-bind:key="subject.id"
        :value="subject.id"
      >{{ subject.name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import organizationSectionMixin from '../../../../mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '../../../../mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationSubjectInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Субъект права'
    },

    inputName: {
      default: 'subject_id'
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  }
}
</script>
